import {Component} from '@angular/core';
import {EnvService} from '@app/core/services/EnvService';
import {ufn} from '@edifecs/fp-ui-lib';
import { StringUtils } from '@app/core/util/StringUtils';

/**
 * Custom component for env switcher nav link.
 */
@Component({
    selector: 'app-env-nav-link',
    template: `
        <span class="title" [title]="title">{{title}}</span>
        <img class="icon" src="assets/fp-ui-lib/images/ic_caret.svg" aria-hidden="true" alt=""/>
    `,
    styles: [`
        :host {
            display: flex;
            flex-direction: row;
            align-items: center;
            cursor: pointer;
            border-bottom: 1px solid var(--fp-side-nav-border-color);
        }

        .title {
            min-width: 0;
            flex: 1;
            padding: 6px 0;
            color: #eeeeee;
            text-transform: uppercase;
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
            text-align: center;
            font-size: 11px;
        }

        .icon {
            width: 10px;
            height: 10px;
            flex-shrink: 0;
            flex-grow: 0;
        }
    `],
    standalone: false
})
export class EnvNavLinkComponent {

    /**
     * Constructor
     * @param envSvc Environment service
     */
    constructor(readonly envSvc: EnvService) {
    }

    /**
     * @internal
     * Get title text to display.
     */
    get title(): string {
        // 4 characters from env short id
        const esn = StringUtils.parseText(this.envSvc.current?.env?.shortName, 4)
        // 2 characters from server short id
        const ssn = StringUtils.parseText(this.envSvc?.current?.srv?.shortName, 2);

        return [esn, ssn].filter(ufn.isText).join(':');
    }
}
